import UpdateMember from "../../../../components/@users/members/UpdateMember";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { ownerTypes } from "../../../../schema/users/memberSchema";

export default function MemberUpdatePage() {

    return (
        <UpdateMember 
            routeType={routeTypes.retail}
            ownerType={ownerTypes.retailer}
        />
    )
}       